import LANGUAGES from "./languages.yaml";

export default {
  data() {
    return {
      languages: LANGUAGES,
    };
  },
  methods: {
    setLocale(locale) {
      localStorage.setItem("LOCALE", locale);
      this.$root.$i18n.locale = locale;
    },
  },
};
